.globalWrapper {
  display: flex;
  flex-direction: row;
  align-items: stretch;
  overflow: hidden;
  height: 100vh;
}

.globalWrapperTop {
  flex-direction: column;
}

.routerWrapper {
  margin: 20px 20px 20px 0px;
  border: 1px solid var(--semanticColorsBodyDivider);
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.navigationWrapper {
  position: relative;
  min-width: 220px;
  border: 0;
  margin: 20px;
}

.navigationWrapperTop {
  min-width: auto;
  width: auto;
  margin: 0px;
  border: 0;
}

.routerWrapperTop {
  margin: 0px 20px 20px 20px;
  width: auto;
  flex: 1;
  min-height: 0;
  border-top: 1px solid var(--semanticColorsBodyDivider);
}

.routerWrapperEmbedded {
  border: 0;
  border-top: 0;
  margin: 0;
}

@media screen and (max-width: 640px) {
  .globalWrapper {
    flex-direction: column;
    height: auto;
  }

  .routerWrapper {
    margin: 0px;
    width: auto;
  }

  .navigationWrapper {
    margin: 0px;
  }

  .navigationWrapperTop {
    margin: 0px;
  }

  .routerWrapperTop {
    margin: 0px;
  }
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: var(--paletteNeutralQuaternaryAlt);
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--paletteNeutralTertiaryAlt);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: var(--paletteNeutralSecondaryAlt);
}
